import { Typography } from "@material-ui/core";
import BlueQuote from "assets/web/BlueQuote.svg";
import { createUseStyles } from "react-jss";
import ReactMarkdown from "react-markdown";

const useStyles = createUseStyles({
    container: {
        margin: '0 auto!important',
        backgroundColor: "#edf4fa",
        borderRadius: "17px",
        padding: "30px",
        width: "90%",
        display: "flex",
        flexDirection: "column",
    },
    image: {
        margin: "0 auto",
        "& img": {
            textAlign: "center",
            marginRight: "10px",
        }
    },
    wrapper: {
        position: "relative",

    },
    quote: {
        position: "absolute",
        left: 0,
        top: 0,
    },
    testimonialContainer: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
        width: "80%",
        margin: "0 auto",
    },
    reviewerContainer: {
        display: "flex",
        justifyContent: "flex-end",
    },
    '@media screen and (max-width:760px)': {
        container: {
            width: "98%",
            display: "flex"
        },
        quote: {
            left: 0,
            top: 0,
        },
        testimonialContainer: {
            width: "100%",
        },
        reviewerContainer: {
            // marginTop: "20px"
        }
    }
})


function TeacherTestimonialCard({
    data,
}) {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.image}>
                <img
                    src={data.coach.image}
                    alt={data.coach.name}
                />
            </div>
            <Typography
                variant="h5"
                className="center"
            >
                {data.title}
            </Typography>

            <div className={classes.wrapper}>
                <div className={classes.testimonialContainer}>

                    <div className={classes.quote}>
                        <BlueQuote />
                    </div>
                    <div>
                        <ReactMarkdown
                            source={data.testimonial}
                        />
                    </div>
                    <div className={classes.reviewerContainer}>
                        <Typography>
                            <b>{data.reviewer}</b>
                        </Typography>
                    </div>
                    {/* <div className={classes.reviewerContainer}>
                        <div>
                            <Typography>
                                {data.coach.name}
                            </Typography>
                            <Typography>
                                {data.coach.designation}
                            </Typography>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default TeacherTestimonialCard;